/* Blissy Halloween layer. Loaded (deferred) only while Theme settings > Seasonal theme is on. */
(() => {
  const root = document.documentElement;

  /* Card hover spider: plays once per card per visit. Delegated, so cards added later (filters, search) work too. */
  if (root.classList.contains('hw-card-spider') && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    const key = 'hw-spider-seen';
    let seen = [];
    try { seen = JSON.parse(sessionStorage.getItem(key)) || []; } catch (error) { seen = []; }
    const cardFrom = (node) => (node instanceof Element ? node.closest('.blissy-product-card') : null);
    document.addEventListener('mouseover', (event) => {
      const card = cardFrom(event.target);
      if (card && seen.includes(card.getAttribute('href'))) card.classList.add('hw-spider-seen');
    });
    document.addEventListener('mouseout', (event) => {
      const card = cardFrom(event.target);
      if (!card || card.contains(event.relatedTarget)) return;
      card.classList.add('hw-spider-seen');
      const id = card.getAttribute('href');
      if (!id || seen.includes(id)) return;
      seen.push(id);
      try { sessionStorage.setItem(key, JSON.stringify(seen)); } catch (error) { /* storage unavailable: replays are harmless */ }
    });
  }
})();
